export const ROUTEHOME = '/';
export const ROUTEADMIN = '/admin';
export const ROUTEUI = '/ui';
export const ROUTEOPENAPI = '/openapi';
export const ROUTESETTINGS = '/settings';
export const ROUTELOGIN = '/login';
export const ROUTESIGNUP = '/signup';
export const ROUTECHANGEPASSWORD = '/changepassword';
export const ROUTERESETPASSWORD = '/resetpassword';
export const ROUTEREQUESTRESETPASSWORD = '/requestresetpassword';
export const ROUTEABOUT = '/about';
export const ROUTEABOUT2 = '/about2';
